const Button = props => {
    const buttonURL = props.buttonURL
    const buttonColour = props.buttonColour

    return(
        <div className="pos-relative nisBtn">
        {buttonURL ? <a href={buttonURL} title={props.buttonTitle}><button type="button" className="btn btn-sm" style={buttonColour ? {backgroundColor :buttonColour} : {backgroundColor :'#ee32a2'}} onClick={props.onClick}>{props.children}</button></a> : <a><button  className="btn btn-sm btn-default btn-noAction" >{props.children}</button></a>}
        </div>

    )
}

export default Button